import { render, staticRenderFns } from "./serviceSlide.vue?vue&type=template&id=393b68ae"
import script from "./serviceSlide.vue?vue&type=script&lang=js"
export * from "./serviceSlide.vue?vue&type=script&lang=js"
import style0 from "./serviceSlide.vue?vue&type=style&index=0&id=393b68ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports